import { ChangeDetectionStrategy, Component, computed, input, model, ViewEncapsulation } from "@angular/core";
import { DropDownItem } from "../../pojo/DropDownItem";
import { DropDownPaginatedModel } from "../../pojo/DropDownPaginatedModel";
import { Nullable } from "../../pojo/Util";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { AriaLabel } from "../../util/aria/aria.label";
import { S25DropdownPaginatedModule } from "../s25-dropdown/s25.dropdown.paginated.module";

// TODO: delete this when event-form is in Angular, and we can just inline the template
//  we need it for now because I couldn't figure out a way to pass a template from angJS
@TypeManagerDecorator("s25-ng-event-form-profile-dropdown")
@Component({
    selector: "s25-ng-event-form-profile-dropdown",
    template: `
        <s25-dropdown-paginated
            [model]="dropdownModel()"
            [chosen]="value() ?? undefined"
            [onSelect]="onSelect()"
            [choice]="choiceTmpl"
            [ariaLabel]="ariaLabel()"
            (chosenChange)="value.set($event)"
        />

        <ng-template #choiceTmpl let-item="item">
            <div>
                <div [innerHTML]="item.profile_name || item.itemName"></div>
                @if (item.profile_description) {
                    <div>{{ item.profile_description }}</div>
                }
                @if (item.profile_comments) {
                    <div>{{ item.profile_comments }}</div>
                }
            </div>
        </ng-template>
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [S25DropdownPaginatedModule],
})
export class EventFormProfileDropdownComponent {
    readonly items = input<DropDownItem[]>([]);
    readonly value = model<Nullable<DropDownItem>>(null);
    readonly onSelect = input<(item: Nullable<DropDownItem>) => void>(() => {});
    readonly ariaLabel = input<AriaLabel>("Choose a segment to edit");
    readonly placeholder = input("Choose a segment to edit");

    readonly dropdownModel = computed(
        (): DropDownPaginatedModel => ({
            searchEnabled: true,
            itemNameProp: "itemName",
            placeholder: this.placeholder(),
            items: this.items() ?? [],
        }),
    );
}
